/* eslint-disable max-len */
export const INIT_INPUT_VALUES = {
  email: '',
  firstName: '',
  lastName: '',
  company: '',
  industry: 0,
  businessSegment: 0,
  refer: 0,
};

export const INIT_ADDRESS = {
  city: '',
  country: 0,
  state: 0,
  streetAddress1: '',
  streetAddress2: '',
  zipCode: '',
  phone: {
    countryId: 229,
    number: '',
    ext: '',
  },
};

export const INIT_INPUT_ERRORS = {
  email: '',
  firstName: '',
  lastName: '',
  company: '',
  industry: '',
  businessSegment: '',
  country: '',
  shippingEmail: '',
  refer: '',
  hasValidationErrors: false,
};

export const INIT_ADDRESS_ERRORS = {
  city: '',
  country: '',
  state: '',
  streetAddress1: '',
  streetAddress2: '',
  zipCode: '',
  hasValidationErrors: false,
};

export const INIT_ALERT_ERRORS = {
  email: '',
  firstName: '',
  lastName: '',
  company: '',
  industry: '',
  businessSegment: '',
  country: '',
  contactPhone: '',
  contactCity: '',
  contactState: '',
  contactAddress1: '',
  contactZipCode: '',
  shippingEmail: '',
  billingEmail: '',
  billingFirstName: '',
  billingLastName: '',
  billingCompany: '',
  billingPhone: '',
  billingCity: '',
  billingState: '',
  billingAddress1: '',
  billingZipCode: '',
  hasValidationErrors: false,
  refer: '',
};
